import { render, staticRenderFns } from "./CellFormatter.vue?vue&type=template&id=4e311072&scoped=true&"
import script from "./CellFormatter.vue?vue&type=script&lang=ts&"
export * from "./CellFormatter.vue?vue&type=script&lang=ts&"
import style0 from "./CellFormatter.vue?vue&type=style&index=0&id=4e311072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e311072",
  null
  
)

export default component.exports